function _extends(){return _extends=Object.assign?Object.assign.bind():function(n){for(var e=1;e<arguments.length;e++){var t=arguments[e];for(var r in t)({}).hasOwnProperty.call(t,r)&&(n[r]=t[r])}return n},_extends.apply(null,arguments)}import*as React from"react";import styled from"@emotion/styled";import{Button,Col}from"@wp/src/components/common";import{FlexLayout,mediaQuery}from"@wp/src/components/common/grid";import{Body2W400Neutral500}from"@wp/src/components/common/atoms";import{css}from"@emotion/react";import{Icon}from"@wp/src/components/common";export const InstitutionContainer=styled(Col)`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  border: ${props=>props.selected?`2px solid ${props.theme.colors.blue600}`:`2px solid ${props.theme.colors.neutral200}`};
  box-sizing: border-box;
  border-radius: var(--card-border-radius, 8px);
  min-width: 24%;
  justify-content: ${props=>props.isMobilePortrait||props.compactMode?"center":"flex-start"};

  ${mediaQuery({padding:["8px"],marginRight:["0","8px","8px"]})};
`;export const SpinnerContainer=styled(FlexLayout)`
  cursor: pointer;
  width: 100%;
`;export const InstitutionImage=styled.img`
  background-color: ${props=>props.backgroundColor};
  width: ${props=>props.width?props.width:mediaQuery({width:["24px"]})};
  height: ${props=>props.height?props.height:mediaQuery({height:["24px"]})};
  left: 16px;
  top: 12px;
  border-radius: 40px;
`;const institutionTextContainerStyles=wrapText=>css`
  white-space: ${wrapText?"pre-wrap":"nowrap"};
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: normal;
`;export const InstituteNameContainer=styled.div`
  ${props=>institutionTextContainerStyles(props.wrapText)};
`;export const InstituteUrlContainer=styled(Body2W400Neutral500)`
  ${props=>institutionTextContainerStyles(props.wrapText)};
`;export const InstitutionAccountProviderLabel=styled(Body2W400Neutral500)`
  text-align: right;

  ${mediaQuery({fontSize:["12px","14px"],lineHeight:["16px"]})};
`;export const ReconnectAccountButton=props=>React.createElement(Button,_extends({type:"primary"},props,{size:"sm"}),"Reconnect");export const AddAccountsIcon=({className})=>React.createElement(Icon,{icon:"lucide:plus-circle",className:`cursor-pointer ${className}`});export const AddAssetButton=styled(Button)({});export const PortfolioConnectAssuranceContainer=styled(FlexLayout)`
  flex-direction: row;
  display: inline-flex;
  flex-wrap: nowrap;
  align-items: center;
  border-radius: 8px;
  column-gap: 16px;
  padding: 10px 16px;
  border: 1px solid;
  border-color: ${props=>props.theme.colors.neutral300};
  background: ${props=>props.theme.colors.white};
  box-shadow: 0 2px 4px 0 rgba(15, 23, 42, 0.16);

  svg {
    min-width: 40px;
    min-height: 40px;
  }
`;